// extracted by mini-css-extract-plugin
export default {"category":"CarouselItem_category__NFgFu","chain":"CarouselItem_chain__IQVDp"};